import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import DigiProtectedRoute from "./DigiProtectedRoute";
import Layout from "./components/Layout";
import Blog from "./screens/Blog";
import AddBlog from "./screens/Blog/AddBlog";
import BlogDetails from "./screens/Blog/BlogDetails";
import Queries from "./screens/Queries";
import Media from "./screens/Media";
import AddMedia from "./screens/Media/AddMedia";
import Testimonial from "./screens/Testimonial";
import AddTestimonial from "./screens/Testimonial/AddTestimonial";
import Associate from "./screens/Associate";
import AddAssociate from "./screens/Associate/AddAssociate";
import Careers from "./screens/Careers";
import AddCareers from "./screens/Careers/AddCareers";
import JobApplicatsDetails from "./screens/Careers/JobApplicatsDetails";
import Employee from "./screens/Employee";
import AddEmployee from "./screens/Employee/AddEmployee";
import Policy from "./screens/Policy";
import EditPolicy from "./screens/Policy/EditPolicy";
import BigFiles from "./screens/BigFiles";

function DigiRouter() {
  return (
    <Routes>
      <Route element={<DigiProtectedRoute />}>
        <Route element={<Layout />}>
          <Route index element={<Queries />} />
          <Route path="blog" element={<Blog />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="blog-details" element={<BlogDetails />} />
          <Route path="media" element={<Media />} />
          <Route path="add-media" element={<AddMedia />} />
          <Route path="testimonial" element={<Testimonial />} />
          <Route path="add-testimonial" element={<AddTestimonial />} />
          <Route path="associated" element={<Associate />} />
          <Route path="add-associated" element={<AddAssociate />} />
          <Route path="careers" element={<Careers />} />
          <Route path="add-careers" element={<AddCareers />} />
          <Route path="career-details" element={<JobApplicatsDetails />} />
          <Route path="policy" element={<Policy />} />
          <Route path="edit-policy" element={<EditPolicy />} />
          <Route path="users" element={<Employee />} />
          <Route path="add-users" element={<AddEmployee />} />
          <Route path="big-files" element={<BigFiles />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default DigiRouter;
